export const my_strings = {
  contact: {
    phonenumber: '+254 701 089536',
    info_email: 'info@flexautomation.co.ke',
    main_email: '',
    sales_email: 'sales@flexautomation.co.ke',
  },
};
